import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

/**
 * Opération custom `POST /imports/{id}/plan/render` : re-rend le fond avec la transform
 * GELÉE en excluant les POI cochés. Appel :
 * `setId(importId).save({ method: 'post', patchAttributes: { excludedHandles } })`.
 */
@doc.path('/imports/{id}/plan/render')
export default class DxfRenderModel extends MapServiceModel {
	@doc.string declare svgDataUri: string;
}
